import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalMaxHeight,
   ModalWidth,
} from '@dreryk/react-components';
import { commonTranslationKeys } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

import { AppointmentNoteFormBean, AppointmentNoteManagementForm } from './AppointmentNoteManagementForm';
import { AppointmentNoteUpdateAction } from './AppointmentNoteManagementModal.actions';

type AppointmentNoteManagementModalProps = {
   readonly appointmentId: number;
   readonly appointmentNote?: string;
   readonly onClose: VoidFunction;
   readonly onSuccess: VoidFunction;
};

export const AppointmentNoteManagementModal = (props: AppointmentNoteManagementModalProps): JSX.Element => {
   const formInitializer = (): AppointmentNoteFormBean => ({ note: props.appointmentNote ?? null });

   return (
      <Modal
         testId={'appointmentNoteManagementModal'}
         title={
            props.appointmentNote
               ? translationKeys.noteManagement.update.label
               : translationKeys.noteManagement.create.label
         }
         width={ModalWidth.NORMAL}
         height={ModalMaxHeight.TALL}
      >
         <AppointmentNoteManagementForm initializer={formInitializer}>
            {({ handleSubmit }) => (
               <>
                  <AppointmentNoteUpdateAction appointmentId={props.appointmentId} onSuccess={props.onSuccess}>
                     {({ updateAppointmentNote }) => (
                        <ModalConfirmButton
                           label={props.appointmentNote ? commonTranslationKeys.save : commonTranslationKeys.add}
                           onClick={handleSubmit(updateAppointmentNote)}
                           blockingOperation
                        />
                     )}
                  </AppointmentNoteUpdateAction>
                  <ModalCancelButton onClick={props.onClose} />
                  <ModalCloseButton onClick={props.onClose} />
               </>
            )}
         </AppointmentNoteManagementForm>
      </Modal>
   );
};
